import React from 'react';

import I18n from 'utils/I18n';

import { useCheckoutContext } from '../../state/CheckoutContext';

import Card from '../shared/Card';
import Inset from '../shared/Inset';
import DurationSelectSideBySide from './DurationSelectSideBySide';
import PricingList from './PricingList';
import SubscriptionFeatures from '../shared/SubscriptionFeatures';
import Footer from './Footer';
import {
  I18nPrefixOrganic,
  I18nPrefixSubscriptionPreview,
  I18nPrefixFatmap
} from '../../shared/constants';

import styles from './Summary.scss';

export const Summary = () => {
  const { checkoutEntityState } = useCheckoutContext();
  const {
    experiments,
    analyticsData
  } = checkoutEntityState;
  const { shouldShowSubscriptionPreview } = experiments;
  const isFromFatmap = analyticsData.origin === 'fatmap';

  const title = () => {
    if (shouldShowSubscriptionPreview) {
      return I18n.t(`${I18nPrefixSubscriptionPreview}.title`)
    }
    if (isFromFatmap) {
      return I18n.t(`${I18nPrefixFatmap}.title_v2`)
    }
    return I18n.t(`${I18nPrefixOrganic}.title`);
  }

  return (
    <div className={styles.checkoutSummary}>
      <Card className={styles.card}>
        <Inset className={styles.overviewSection}>
          <h4 className={styles.overviewTitle}>{title()}</h4>
          <div className={styles.overviewDescription}>
            <SubscriptionFeatures />
          </div>
        </Inset>
        <Inset>
          <DurationSelectSideBySide />
        </Inset>
        <PricingList />
        <Inset className={styles.summaryFooter}>
          <Footer />
        </Inset>
      </Card>
    </div>
  );
};

export default Summary;
